import React, { useRef, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import tutorialSlideOne from "../images/tutorials/tutorial_0.png";
import tutorialSlideTwo from "../images/tutorials/tutorial_2.png";
import tutorialSlideThree from "../images/tutorials/tutorial_3.png";
import tutorialSlideFour from "../images/tutorials/tutorial_4.png";
import tutorialSlideFive from "../images/tutorials/tutorial_5.png";
import { ThemeAudioContext } from "./ThemeAudioContext";

const TutorialSliderIntro = ({ onSliderEndClick }) => {
  const {
    toggleAudio,
    enabled,
    setAudioSource,
    pauseThemeAudio,
    resumeThemeAudio,
    reduceThemeAudioVolume,
    restoreThemeAudioVolume,
  } = useContext(ThemeAudioContext);

  const lang = localStorage.getItem("language") || "en";


  // Slide Data
  const slides = [
    {
      desc: "Hotspot Location",
      img: tutorialSlideOne,
      text: {
        en: "To access detailed information about a particular hotspot, simply click on the yellow bubble associated with it.",
        sl: "විශේෂිත හොට්ස්පොට් එකක් පිළිබඳ සවිස්තරාත්මක තොරතුරු වෙත ප්‍රවේශ වීමට, එයට සම්බන්ධ කහ බුබුල මත ක්ලික් කරන්න.",
        tm: "ஒரு குறிப்பிட்ட ஹாட்ஸ்பாட் பற்றிய விரிவான தகவலை அணுக, அதனுடன் தொடர்புடைய மஞ்சள் குமிழியைக் கிளிக் செய்யவும்.",
      },
      audio: {
        en: "https://res.cloudinary.com/giglantis/video/upload/v1777368912/Hotspot_xmjz7z.mp3",
        sl: "https://res.cloudinary.com/giglantis/video/upload/v1778566231/Hotspot_b2fxlq.mp3",
        tm: "https://res.cloudinary.com/giglantis/video/upload/v1778568925/Hotspot_og76hd.mp3",
      },
    },
    {
      desc: "All Locations",
      img: tutorialSlideTwo,
      text: {
        en: "To view all available locations and navigate to any of them, simply click on the 'All Locations' button located in the left-hand corner.",
        sl: "පවතින සියලුම ස්ථාන බැලීමට සහ ඒවායින් ඕනෑම ස්ථානයකට සැරිසැරීමට, වම් කෙළවරේ ඇති 'සියලු ස්ථාන' බොත්තම ක්ලික් කරන්න.",
        tm: "கிடைக்கக்கூடிய எல்லா இடங்களையும் பார்க்கவும், அவற்றில் ஏதேனும் ஒன்றைப் பார்க்கவும், இடது மூலையில் அமைந்துள்ள 'அனைத்து இருப்பிடங்கள்' பொத்தானைக் கிளிக் செய்யவும்.",
      },
      audio: {
        en: "https://res.cloudinary.com/giglantis/video/upload/v1777369199/All_Locations_n7t7i9.mp3",
        sl: "https://res.cloudinary.com/giglantis/video/upload/v1778566361/All_Location_pucbrq.mp3",
        tm: "https://res.cloudinary.com/giglantis/video/upload/v1778568946/All_Locations_aepyd5.mp3",
      },
    },
    {
      desc: "Next / Previous Location",
      img: tutorialSlideThree,
      text: {
        en: "To move to the next or previous location, simply use the left and right control buttons located at the bottom of the screen.",
        sl: "ඊළඟ හෝ පෙර ස්ථානයට යාමට, තිරයේ පහළින් පිහිටා ඇති වම් සහ දකුණු පාලන බොත්තම් භාවිතා කරන්න.",
        tm: "அடுத்த அல்லது முந்தைய இடத்திற்குச் செல்ல, திரையின் அடிப்பகுதியில் அமைந்துள்ள இடது மற்றும் வலது கட்டுப்பாட்டு பொத்தான்களைப் பயன்படுத்தவும்.",
      },
      audio: {
        en: "https://res.cloudinary.com/giglantis/video/upload/v1777369235/Next_Previous_Navigation_cuppbo.mp3",
        sl: "https://res.cloudinary.com/giglantis/video/upload/v1778566423/Next_Previous_Navigation_dkye8w.mp3",
        tm: "https://res.cloudinary.com/giglantis/video/upload/v1778568961/Next_Previous_Navigation_fnlxpe.mp3",
      },
    },
    {
      desc: "360 View",
      img: tutorialSlideFour,
      text: {
        en: "To explore the 360-degree view of the location, swipe the screen left, right, up and down sides.",
        sl: "ස්ථානයේ අංශක 360 දර්ශනය ගවේෂණය කිරීමට, තිරය වමට, දකුණට, ඉහළට සහ පහළට ස්වයිප් කරන්න.",
        tm: "இருப்பிடத்தின் 360 டிகிரி காட்சியை ஆராய, திரையை இடது, வலது, மேல் மற்றும் கீழ் பக்கமாக ஸ்வைப் செய்யவும்.",
      },
      audio: {
        en: "https://res.cloudinary.com/giglantis/video/upload/v1777369268/360_View_ch5iwa.mp3",
        sl: "https://res.cloudinary.com/giglantis/video/upload/v1778568840/360_view_jbefr7.mp3",
        tm: "https://res.cloudinary.com/giglantis/video/upload/v1778568985/360_View_codret.mp3",
      },
    },
    {
      desc: "Location Navigation",
      img: tutorialSlideFive,
      text: {
        en: "To navigate between different spots within the same location, simply click on the circles located at the bottom of the screen.",
        sl: "එකම ස්ථානය තුළ විවිධ ස්ථාන අතර සැරිසැරීමට, තිරයේ පතුලේ ඇති කව මත ක්ලික් කරන්න.",
        tm: "ஒரே இடத்தில் வெவ்வேறு இடங்களுக்கு இடையே செல்ல, திரையின் அடிப்பகுதியில் உள்ள வட்டங்களில் கிளிக் செய்யவும்.",
      },
      audio: {
        en: "https://res.cloudinary.com/giglantis/video/upload/v1777369290/Hotspot_Navigation_eb06a1.mp3",
        sl: "https://res.cloudinary.com/giglantis/video/upload/v1778568871/Hotspot_Navigation_mjzelf.mp3",
        tm: "https://res.cloudinary.com/giglantis/video/upload/v1778569002/Hotspot_Navigation_qs5g7g.mp3",
      },
    },
  ];

  const swiperRef = useRef(null);
  const audioRef = useRef(new Audio());
  const [activeIndex, setActiveIndex] = useState(0);
  const [playAudio, setPlayAudio] = useState(false);



  // Play audio for activeIndex (autoplay on slide change)
  useEffect(() => {
    reduceThemeAudioVolume();
    const url = slides[activeIndex]?.audio?.[lang];
    if (!url) return;

    // pause previous audio
    audioRef.current.pause();
    audioRef.current.src = url;
    audioRef.current.load();
    // PLAY audio
    audioRef.current
      .play()
      .then(() => setPlayAudio(true))
      .catch(() => setPlayAudio(false));

    // WHEN AUDIO ENDS → set playAudio false
    const handleEnded = () => {
      setPlayAudio(false);
      restoreThemeAudioVolume();
    };

    audioRef.current.addEventListener("ended", handleEnded);

    // CLEANUP when slide changes
    return () => {
      audioRef.current.removeEventListener("ended", handleEnded);
      audioRef.current.pause();
    };
  }, [activeIndex, lang]);

  const handleAudioPlay = () => {
    if (!audioRef.current.src) {
      audioRef.current.src = slides[activeIndex].audio[lang];
      audioRef.current.load();
    }
    reduceThemeAudioVolume();
    audioRef.current
      .play()
      .then(() => setPlayAudio(true))
      .catch(() => setPlayAudio(false));

    const handleEnded = () => {
      setPlayAudio(false)
    };
    audioRef.current.addEventListener("ended", handleEnded);
  };

  const pauseAudioPlay = () => {
    audioRef.current.pause();
    setPlayAudio(false);
    restoreThemeAudioVolume();
  };

  // ← THIS fixes your ReferenceError: use slides array instead of audioUrls
  const onNextSlideClick = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777458934/TUTORIAL_NEXT_mdyrke.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });

    // pause current audio
    audioRef.current.pause();
    setPlayAudio(false);

    const current = swiperRef.current?.activeIndex ?? activeIndex;
    const nextIndex = current + 1;

    // if last slide: end the tutorial
    if (nextIndex >= slides.length) {
      if (typeof onSliderEndClick === "function") {
        onSliderEndClick();
      }
      // reset or keep at last slide
      return;
    }

    // move swiper and set active index (swipe change will also trigger effect)
    if (swiperRef.current && swiperRef.current.slideTo) {
      swiperRef.current.slideTo(nextIndex, 300);
    }
    setActiveIndex(nextIndex);

    // attempt autoplay next audio after small delay so swiper transition can settle
    setTimeout(() => {
      const nextUrl = slides[nextIndex]?.audio?.[lang];
      if (nextUrl) {
        audioRef.current.src = nextUrl;
        audioRef.current.load();
        audioRef.current
          .play()
          .then(() => setPlayAudio(true))
          .catch(() => setPlayAudio(false));
      }
    }, 200);
  };



  return (
    <section>
      <Swiper
        spaceBetween={40}
        slidesPerView={1}
        onSwiper={(sw) => (swiperRef.current = sw)}
        onSlideChange={(sw) => {
          // ensure audio and state follow the swiper's active index
          pauseAudioPlay();
          setActiveIndex(sw.activeIndex);
        }}
      >
        {slides.map((slide, idx) => (
          <SwiperSlide key={idx}>
            <div className="flex-column-container">
              <div className="tutorial-content-row">
                <img className="tutorial-slide-img" src={slide.img} alt="" />

                <section className="tutorial-content-desc-container">
                  <section className="tutorial-audio-container mb-2">
                    {!playAudio && (
                      <div className="flex-row-center">
                        <span className={`info-view-text ${idx === 2 ? "info-view-text-lg" : ""
                          }`}>{slide.desc}</span>
                        <div className={`audio-icon-container ${idx === 2 ? "audio-icon-container-lg" : ""
                          }`}
                          onClick={handleAudioPlay}
                        >
                          <div className="audio-img" />
                        </div>
                      </div>
                    )}

                    {playAudio && (
                      <div
                        className="tutorial-audio-contain audio-container"
                        onClick={pauseAudioPlay}
                      >
                        <ul className="tutorial-audio-div audio-div">
                          {Array.from({ length: 15 }).map((_, i) => (
                            <li key={i} className="audio-wave" />
                          ))}
                        </ul>

                        <div
                          className="audio-icon-container"
                          onClick={pauseAudioPlay}
                        >
                          <div className="audio-pause-img" />
                        </div>
                      </div>
                    )}
                  </section>

                  <span className="tutorial-desc">{slide.text[lang]}</span>
                </section>
              </div>

              <div className="ellipse-group">
                {slides.map((_, i) => (
                  <div
                    key={i}
                    className={
                      i === activeIndex
                        ? "ellipse-circle-active"
                        : "ellipse-circle"
                    }
                    onClick={() => {
                      if (swiperRef.current?.slideTo) {
                        swiperRef.current.slideTo(i);
                        pauseAudioPlay();
                        setActiveIndex(i);
                      }
                    }}
                  />
                ))}
              </div>

              <Button
                className="tutorial-next-btn"
                variant="contained"
                onClick={() => onNextSlideClick()}
              >
                {lang === "en"
                  ? idx === slides.length - 1
                    ? "Done"
                    : "Next"
                  : lang === "sl"
                    ? idx === slides.length - 1
                      ? "ඉවරයි"
                      : "ඊළඟ"
                    : idx === slides.length - 1
                      ? "முடிந்தது"
                      : "அடுத்தது"}
              </Button>

              <span
                className="skip-link"
                onClick={() => {
                  audioRef.current.pause();
                  if (typeof onSliderEndClick === "function")
                    onSliderEndClick();
                }}
              >
                {lang === "en"
                  ? "Skip"
                  : lang === "sl"
                    ? "මඟ හරින්න"
                    : "தவிர்க்கவும்"}
              </span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Hidden native audio (we use audioRef.current which is an Audio instance) */}
      <audio className="hide-audio" style={{ display: "none" }} />
    </section>
  );
};

export default TutorialSliderIntro;
